import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

interface IProps {
  currentStep: string;
  onCancel: () => void | Promise<void>;
  onGenerate: () => void | Promise<void>;
  onApply: () => void | Promise<void>;
  onStartOver: () => void | Promise<void>;
  prompt: string;
  isModelFailure?: boolean;
  isResponseFailure?: boolean;
}

function SegmentBuilderModalActions({
  currentStep,
  onCancel,
  onGenerate,
  prompt,
  onApply,
  onStartOver,
  isModelFailure,
  isResponseFailure,
}: Readonly<IProps>): JSX.Element | null {
  const { t } = useTranslation();

  const renderInputButtons = (): JSX.Element | null => (
    <>
      <Button onClick={onCancel} type={'secondary'}>
        {t('Cancel')}
      </Button>
      <Button
        disabled={!prompt.trim()}
        onClick={onGenerate}
        prefix={getIconForAction('magic')}
        type={'recommendation'}
      >
        {t('Generate Group')}
      </Button>
    </>
  );

  const renderResultsButtons = (): JSX.Element => {
    if (isModelFailure) {
      return (
        <>
          <Button onClick={onCancel} type={'secondary'}>
            {t('Cancel')}
          </Button>
          <Button onClick={onStartOver} type={'primary'}>
            {t('Try a different prompt')}
          </Button>
        </>
      );
    }

    if (isResponseFailure) {
      return (
        <>
          <Button onClick={onCancel} type={'secondary'}>
            {t('Try again')}
          </Button>
          <Button onClick={onCancel} type={'secondary'}>
            {t('Cancel')}
          </Button>
        </>
      );
    }
    return (
      <>
        <Button onClick={onStartOver} type={'secondary'}>
          {t('Try a different prompt')}
        </Button>
        <Button onClick={onApply} type={'primary'}>
          {t('Apply Group')}
        </Button>
      </>
    );
  };

  const getModalFooter = (): JSX.Element | null => {
    switch (currentStep) {
      case 'input':
        return renderInputButtons();

      case 'processing':
        return null;

      case 'results':
        return renderResultsButtons();

      default:
        return null;
    }
  };

  return getModalFooter();
}

export default SegmentBuilderModalActions;
